import { c as _c } from "react/compiler-runtime";
import { DotEnvProvider } from './context.tsx';
const env = {
  API_URL: process.env.API_URL,
  BACKEND_URL: process.env.BACKEND_URL,
  CARGOKING_SHIPPER_URL: process.env.CARGOKING_SHIPPER_URL,
  GOOGlE_API_KEY: process.env.GOOGlE_API_KEY,
  KCHARLES_URL: process.env.KCHARLES_URL,
  POSTHOG_HOST: process.env.POSTHOG_HOST,
  POSTHOG_KEY: process.env.POSTHOG_KEY,
  PUSHER_APP_KEY: process.env.PUSHER_APP_KEY,
  PUSHER_CLUSTER: process.env.PUSHER_CLUSTER,
  PUSHER_WS_HOST: process.env.PUSHER_WS_HOST,
  PUSHER_WS_PORT: process.env.PUSHER_WS_PORT,
  SOURCE: process.env.SOURCE
};
export const EnvProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <DotEnvProvider env={env}>{children}</DotEnvProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};